import { render, staticRenderFns } from "./lgexportorder.vue?vue&type=template&id=5fec2958&"
import script from "./lgexportorder.vue?vue&type=script&lang=js&"
export * from "./lgexportorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports